module.exports = __webpack_public_path__ + "img/cooperate_qy_02@2x.342b53e4.png";